import { Column } from './types'

import styles from './useHeaderColumnProps.scss'


export const headerProps = {
  [Column.Title]: { alignLeft: true, className: styles.columnTitle },
  [Column.Date]: { alignLeft: true },
  [Column.Children]: { alignRight: true },
  [Column.Sum]: { alignRight: true },
  [Column.Action]: { alignLeft: true },
}

export function useHeaderColumnProps() {
  return headerProps
}
